module.exports = {"220802001":"海明街道","220802002":"长庆街道","220802003":"瑞光街道","220802004":"明仁街道","220802005":"铁东街道","220802006":"城南街道（工业园区）","220802007":"新立街道","220802009":"新华街道","220802100":"平安镇","220802101":"青山镇","220802102":"林海镇","220802103":"洮河镇","220802104":"平台镇","220802105":"到保镇","220802170":"岭下镇（查干浩特旅游经济开发区）（省级）","220802200":"东风乡","220802201":"三合乡","220802202":"东胜乡","220802203":"金祥乡","220802204":"德顺蒙古族乡","220802402":"镇南种羊场","220802403":"白城牧场","220802404":"洮儿河农场","220802405":"保民农场","220802406":"到保林场","220802407":"白城市生态新区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/220802.json
// module id = 658
// module chunks = 0